import React from "react";
import "./HomeProductCard.scss";
import { useProductQuery } from "../../../hooks/useReactQuery";
import { Link } from "react-router-dom";

const HomeProductCard = () => {
  const { Prefetch: getAllProductsQuery } = useProductQuery();
  const getAllProducts = getAllProductsQuery();

  return (
    <div className="home_product_card_container">
      {getAllProducts.data?.data !== undefined
        ? getAllProducts.data?.data.slice(0, 8).map((product, index) => (
            <Link
              to={`/product-details/${product._id}`}
              className="product_card"
              key={index}
            >
              <div className="img_wrapper">
                <div className="product_img">
                  <img
                    src={product.images[0].replace(
                      "/upload/",
                      "/upload/f_auto,q_auto,c_fill/"
                    )}
                    alt="product"
                    loading="lazy"
                    width={200}
                    height={250}
                  />
                  <div className="img_bridge">New</div>
                </div>
              </div>
              <div className="product_name">{product.name}</div>
              <div className="product_price">
                View Product -{" "}
                <span className="text-[#FFA52F]">₹{product.price}</span>
              </div>
            </Link>
          ))
        : [...Array(12)].map((_, index) => {
            return (
              <div className="skeleton_card" key={index}>
                <div className="skeleton_image" />
                {/* <div className="skeleton_text short" /> */}
                <div className="skeleton_text" />
                <div className="skeleton_button" />
              </div>
            );
          })}
    </div>
  );
};

export default HomeProductCard;
